import script from "./expenses-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./expenses-modal.vue?vue&type=script&setup=true&lang=js"

import "./expenses-modal.vue?vue&type=style&index=0&id=2747b6ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2747b6ce"]])

export default __exports__